"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allCryptoCurrencies = exports.getCryptoCurrencyList = void 0;
const constants_1 = require("../data/constants");
const cryptoOptions_1 = __importDefault(require("../data/cryptoOptions"));
const getCryptoCurrencyList = (defaultCurrency) => {
    const priorityCryptos = constants_1.PRIORITY_CRYPTO.reduce((p, c) => (defaultCurrency !== c ? Object.assign(Object.assign({}, p), { [c]: [c] }) : p), {});
    const otherCurrencies = Object.keys(cryptoOptions_1.default).reduce((p, c) => !constants_1.PRIORITY_CRYPTO.includes(c) ? Object.assign(Object.assign({}, p), { [c]: cryptoOptions_1.default[c] }) : p, {});
    if (defaultCurrency && cryptoOptions_1.default[defaultCurrency]) {
        return Object.assign(Object.assign({ [defaultCurrency]: cryptoOptions_1.default[defaultCurrency] }, priorityCryptos), otherCurrencies);
    }
    return Object.assign(Object.assign({}, priorityCryptos), otherCurrencies);
};
exports.getCryptoCurrencyList = getCryptoCurrencyList;
const allCryptoCurrencies = (isSell) => {
    if (isSell)
        return Object.keys((0, exports.getCryptoCurrencyList)())
            .map((i) => (Object.assign({ code: i }, cryptoOptions_1.default[i])))
            .filter((c) => !c.buyOnly);
    return Object.keys((0, exports.getCryptoCurrencyList)()).map((i) => (Object.assign({ code: i }, cryptoOptions_1.default[i])));
};
exports.allCryptoCurrencies = allCryptoCurrencies;
//# sourceMappingURL=crypto.js.map